export default "__VITE_ASSET__rgPjJjGx__"